module.exports = __webpack_public_path__ + "static/media/ic_short_term_inv.7a353b1b.svg";